import React, {useState, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import {Link} from 'react-router-dom'


// import './App.css'

const ItemDetail = ({match}) => {
useEffect(() => {
    fetchItem()
    console.log(match)
}, []);

const [item, setItem]= useState(
  []
)

const fetchItem = async()=>{
    const deleteSpace=match.params.name.split(" ").join("")
const fetchItem= await fetch(`https://api.spoonacular.com/recipes/findByNutrients?min${deleteSpace}=1&max${deleteSpace}=100&number=15&apiKey=baa0813f65954e668aee0d31947401d3`)
const item = await fetchItem.json();
setItem(item)

}


return (
    <div>
  <Link to='/vitamins'>  <button className='back-button'>back to menu</button></Link>
  
<center><h1 className='receipt-title'>{match.params.name}</h1></center>

     {item.map((listItem)=>(

<Grid container justify='center' className='grid-receipt'>
{console.log(listItem)}
         <div key={listItem.id}>

         {/* <h1>{match.params.name}</h1> */}
         <Grid item xs={5} style={{maxWidth:'300px', margin:'50px auto 20px auto'}}>
        <h2> {listItem.title}</h2>
         </Grid>
         <Grid item xs={5}>
       <img src={listItem.image} alt={listItem.title}
            
        />
         </Grid>
         <Grid item xs={6}>
           <p> Kcal: {listItem.calories}</p> 
           <p> Carbs: {listItem.carbs}</p> 
           <p> Fat : {listItem.fat}</p> 
           <p>Proteins : {listItem.protein}</p>

         </Grid>
         </div>
</Grid>
     ))}
    </div>
)

}

export default ItemDetail
